// extracted by mini-css-extract-plugin
export default {"cardContainer":"mapHotelCardSmall-module__cardContainer__0z5d+","hotelInfo":"mapHotelCardSmall-module__hotelInfo__3gJet"};